// extracted by mini-css-extract-plugin
export var container = "_dm-0";
export var icon = "_dm-1";
export var text = "_dm-2";